import React, { useEffect, useState } from 'react';
import './Footer.css';
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faMapMarkerAlt, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

export default function Footer() {
    const [tienda, setTienda] = useState({});
    const [categorias, setCategorias] = useState([]);

    useEffect(() => {
        cargarCategorias();
        cargarTienda();
    }, []);

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias?.slice(0, 4) || []);
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda?.[0] || {});
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    return (
        <footer className='footer'>
            <div className='footer__inner'>
                <div className='footer__brand'>
                    <Anchor to='/' className='footer__logo'>
                        {tienda.imagen1 ? (
                            <img src={tienda.imagen1} alt={tienda.nombre} />
                        ) : (
                            <div className='footer__logoPlaceholder'>S</div>
                        )}
                    </Anchor>
                    <h2 className='footer__nombre'>{tienda.nombre || 'Sistema'}</h2>
                    <p className='footer__eslogan'>{tienda.eslogan || ''}</p>
                </div>

                <div className='footer__column'>
                    <h3>Contacto</h3>
                    <ul className='footer__list'>
                        {tienda.direccion && (
                            <li>
                                <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(tienda.direccion)}`} target='_blank' rel='noopener noreferrer'>
                                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                                    <span>{tienda.direccion}</span>
                                </Anchor>
                            </li>
                        )}
                        {tienda.email && (
                            <li>
                                <Anchor to={`mailto:${tienda.email}`} target='_blank'>
                                    <FontAwesomeIcon icon={faEnvelope} />
                                    <span>{tienda.email}</span>
                                </Anchor>
                            </li>
                        )}
                        {tienda.telefono && (
                            <li>
                                <Anchor to={`tel:${tienda.telefono}`} target='_blank'>
                                    <FontAwesomeIcon icon={faPhone} />
                                    <span>{tienda.telefono}</span>
                                </Anchor>
                            </li>
                        )}
                    </ul>
                    <div className='footer__socials'>
                        {tienda.instagram && (
                            <Anchor to={tienda.instagram} target='_blank' rel='noopener noreferrer' className='footer__socialIcon'>
                                <FontAwesomeIcon icon={faInstagram} />
                            </Anchor>
                        )}
                        {tienda.facebook && (
                            <Anchor to={tienda.facebook} target='_blank' rel='noopener noreferrer' className='footer__socialIcon'>
                                <FontAwesomeIcon icon={faFacebook} />
                            </Anchor>
                        )}
                        {tienda.telefono && (
                            <Anchor to={`https://wa.me/${tienda.telefono}`} target='_blank' rel='noopener noreferrer' className='footer__socialIcon'>
                                <FontAwesomeIcon icon={faWhatsapp} />
                            </Anchor>
                        )}
                    </div>
                </div>

                <div className='footer__column'>
                    <h3>Categorías</h3>
                    <ul className='footer__list'>
                        {categorias.map((item, index) => (
                            <li key={index}>
                                <Anchor to={`/`}>{item.categoria}</Anchor>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className='footer__bottom'>
                <span>&copy; {new Date().getFullYear()} {tienda.nombre || 'Sistema'}. Todos los derechos reservados.</span>
            </div>
        </footer>
    );
}